module.exports = __webpack_public_path__ + "media/images/Enrico_Cozzolino_Assinatura-1af432dd033f7d8b0a43d29999a74dea.png";